const rulesAndInfo = [
	"",
	"The Course",
	"",
	"1.	The Gaborone Golf Course 5kms Run (“GGC5k“) is an approximately 5,000 metre trail run held weekly at the Gaborone Golf Course. The route is marked and timed on alternate weeks.",
	"2.	The golf course is entirely fenced and the route is entirely within the confines of the fenced area.  There should be no risk to runners from vehicles.",
	"3.	The golf course is closed to golfers on Monday’s and so there should be no risk from golfers on the course.",
	"4.	The course has several hazards and poses some risk to runners predominantly due to the off road nature of the route.  Tripping hazards abound and there is a small risk of attack by animals the most dangerous being snakes.  Vigilance and caution should be a priority at all times.",
	"5.	The route will be marked by brightly coloured cones.  You must run to the right of the cones at all times.",
	"6.	The greens must be avoided and are strictly out of bounds. Individuals found running over any of the greens may be banned from taking part in further events.",
	"",
	"The Run",
	"",
	"7.	The event is a social run and it is not a race.  The timing of the runs is for the benefit of individuals to better be able to access their progress over time.",
	"8.	The start times for runs is 1730hrs in summer and 1700hrs in winter. A brief will take place 10 minutes before the start of each run.",
	"9.	Runners should do everything in their power to avoid jostling or physical contact with other runners.",
	"10.	Runners must be 4 years or older to participate and to qualify for a numbered bib.  Children of 11 years and younger must be accompanied by a responsible adult at all times.  We ask that the responsible adult is within 5 metres of the accompanied child at all times during the run.",
	"11.	Children under 18 must have their parents consent to partake in the event.  This consent will be sent once the minor has been registered online.  Confirmation of the minor’s registration and allocated number will be e-mailed upon receipt of the parental consent form.",
	"12.	All runners must be have their QR code with their unique number with them for all the runs.  Your event number will be allocated automatically when you register.  You will keep this number for your first and every subsequent run.  In the event that you destroy or lose your QR code you can regenerate another - ask the organisers for assistance if required.",
	"13.	You may run with headphones but the volume must be turned low enough that you can hear other participants communicating with you during the run.",
	"14.	Participants must bring their own hydration and nutrition for before, during and after the run.",
	"15.	Strollers are also allowed on the course but be aware that the course is rough, sandy and harder to navigate that on a tarred road. ",
	"",
	"Logistics",
	"",
	"16.	 Ample parking is available at the GGC parking area or just outside the main entrance gates.  Please exercise caution when parking.",
	"17.	Male and female changing facilities and toilets are available at the events.",
	"18.	Events will start on time so please arrive at least 20-30 minutes before the run start to ensure you can warm up, hear the run brief and any special notices for that day’s event.",
	"19.	If there is a risk of lightning the run will be cancelled and will either be rescheduled or held as planned two weeks later.",
	"20.	You are encouraged to cheer and encourage finishers who come in after you.",
	"21.	Volunteers are a key part of the success of this community event so please consider helping.",
	"22.	The GGC bar will be open after every event.",
	"",
	"Results",
	"",
	"23.	Results will be finalised shortly after the last runner has completed their run at each event and will available to view at www.ggc5k.com. In the event you do not want your times to be public please e-mail the GGC5K team and inform us of such.",
	"24.	Run categories are as follows for both men and women:",
	"",
	"0 - 10 years old",
	"11 - 19",
	"20 - 29",
	"30 - 39",
	"40 - 49",
	"50 - 59",
	"60 - 69",
	"70 - 79",
	"80 - 89",
	"90 +",
	"	",
	"General Event Advice",
	"",
	"22.  Dress appropriately for the weather conditions.  In summer, wear a hat, sunglasses, sun cream and carry water or be well hydrated before you start.",
	"23. Arrive early to hear the run brief.",
	"24. Check FB and the Website for event updates.",
	"25. Run within your physical limits. ",
	"26. Most importantly - HAVE FUN."
];

module.exports = {
	rulesAndInfo
};
